import { render } from "./WorkModule.vue?vue&type=template&id=6c9d0832"
import script from "./WorkModule.vue?vue&type=script&lang=js"
export * from "./WorkModule.vue?vue&type=script&lang=js"

import "./WorkModule.vue?vue&type=style&index=0&id=6c9d0832&lang=scss"

import exportComponent from "/Users/chenjun/Desktop/myProject/pbl-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__